import {selector} from 'recoil';
import {userDetails} from ".";

export const userData = selector({
  key: 'currentUser',
  get: ({get}) => {
    return get(userDetails);
  }
});